import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
const SearchItemCarousel = ({items, handleBrandClick}) => {
  return (
    <div className="brand-carousel">
      <Swiper
        slidesPerView={6}
        spaceBetween={10}
        loop={true}
        breakpoints={{
          320: { slidesPerView: 4 },
          768: { slidesPerView: 6 },
          1024: { slidesPerView: 8 },
        }}
      >
       {items.siteSearchResultList.map((brand, index) => {
        const lastIndex = brand.type === 'SiteSearchResultTextItem';
          return (<SwiperSlide key={index} className="brand-slide">
            <div className="brand-item">
              <div className="brand_image">
                <img src={brand.image.src} alt={brand.label} onClick={() => handleBrandClick(brand, true, lastIndex)} />
              </div>
              <p>{brand.label}</p>
            </div>
          </SwiperSlide>)
        })}
      </Swiper>
    </div>
  );
};

export default SearchItemCarousel;
